function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2c.278 0 .504.226.504.504v4.992h4.992a.504.504 0 010 1.008H8.504v4.992a.504.504 0 01-1.008 0V8.504H2.504a.504.504 0 010-1.008h4.992V2.504C7.496 2.226 7.722 2 8 2z",
  fill: "#2D2D2D"
});
function SvgSignoms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Signo más.svg";
export { SvgSignoms as ReactComponent };